import React from "react";
import { useLang } from "@/i18n/LanguageProvider";
import { SectionTitle } from "@/components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLang();
  return (
    <div data-testid="page-faq" className="container-px mx-auto pb-24">
      <SectionTitle eyebrow={t.faq.eyebrow} title={t.faq.title} />
      <div className="mt-12 max-w-3xl">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {t.faq.items.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg md:text-xl text-ink py-5 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-ink/75 text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
